/* global axios */
import ApiClient from './ApiClient';

class FlowMediaAssetsAPI extends ApiClient {
  constructor() {
    super('flow_media_assets', { accountScoped: true });
  }

  upload(file, mediaType, flowId = null) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('media_type', mediaType);
    if (flowId) formData.append('flow_id', flowId);
    return axios.post(this.url, formData);
  }
}

export default new FlowMediaAssetsAPI();
